export default __webpack_public_path__ + "static/mit-cav-adf465fcdb490b64227c73d8bc6e4c7a.png";